import { ApiRequest } from '../baseService'

const BaseRoute = 'app/token-lifetime-settings'

const getTenantQuery = (tenantId?: string) =>
  tenantId ? `?tenantId=${tenantId}` : ''

function GetCurrentTenant() {
  return ApiRequest.get(`${BaseRoute}/current`)
}

function UpdateCurrentTenant(payload) {
  return ApiRequest.put(`${BaseRoute}/current`, payload)
}

function GetForTenant(tenantId?: string) {
  return ApiRequest.get(`${BaseRoute}${getTenantQuery(tenantId)}`)
}

function UpdateForTenant(payload, tenantId?: string) {
  return ApiRequest.put(`${BaseRoute}${getTenantQuery(tenantId)}`, payload)
}

const API = {
  GetCurrentTenant,
  UpdateCurrentTenant,
  GetForTenant,
  UpdateForTenant,
}

export default API
